import React from "react";
function HiddenWidget(_ref) {
  var id = _ref.id,
    value = _ref.value;
  return React.createElement("input", {
    type: "hidden",
    id: id,
    value: typeof value === "undefined" ? "" : value
  });
}
if (process.env.NODE_ENV !== "production") {}
export default HiddenWidget;